__webpack_require__.p = "/cdn/release-v1.482.1/public-desktop/";